import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useMediaQuery } from "react-responsive";

const MobileTopics = ({ topics = [], breadСrumbs }) => {
  const isSmallScreen = useMediaQuery({ query: "(max-width: 768px)" });

  useEffect(() => {
    if (!isSmallScreen && window) {
      window.location.href = breadСrumbs[breadСrumbs.length - 2].url;
    }
  }, []);

  return (
    <React.Fragment>
      {topics.lessons.map(
        (lesson, index) =>
          lesson && (
            <a key={lesson.id} className="topics__block" href={lesson.url}>
              <div className="topic__lesson">
                <span className="topics__number">Урок {index}</span>
                <span className="topics__name">{lesson.name}</span>
              </div>
            </a>
          )
      )}
    </React.Fragment>
  );
};

MobileTopics.propTypes = {
  topics: PropTypes.object,
  baseUrl: PropTypes.string,
};

export default MobileTopics;



// WEBPACK FOOTER //
// ./app/frontend/components/MobileTopics.js